import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Check, Loader2, ImageOff } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const MediaLibrary = ({ open, onOpenChange, onSelect, multiple = true }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [picked, setPicked] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    if (!open) return;
    setPicked([]);
    setLoading(true);
    api.get("/admin/media").then(({ data }) => setItems(data)).catch(() => setItems([])).finally(() => setLoading(false));
  }, [open]);

  const toggle = (url) => {
    if (!multiple) return setPicked([url]);
    setPicked((p) => (p.includes(url) ? p.filter((u) => u !== url) : [...p, url]));
  };
  const shown = items.filter((m) => !q || (m.filename || "").toLowerCase().includes(q.toLowerCase()));
  const confirm = () => {
    onSelect(picked.map((u) => `${BACKEND}${u}`));
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[88vh] flex flex-col" data-testid="media-library-dialog">
        <DialogHeader><DialogTitle>Media Library</DialogTitle></DialogHeader>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by file name" data-testid="media-library-search" />
        <div className="flex-1 overflow-y-auto min-h-[240px]">
          {loading ? (
            <div className="flex justify-center py-16"><Loader2 className="animate-spin text-slate-400" /></div>
          ) : shown.length === 0 ? (
            <div className="flex flex-col items-center py-16 text-slate-400 text-sm" data-testid="media-library-empty">
              <ImageOff className="mb-2" /> No uploaded photos yet.
            </div>
          ) : (
            <div className="grid grid-cols-3 sm:grid-cols-5 gap-3" data-testid="media-library-grid">
              {shown.map((m) => {
                const sel = picked.includes(m.url);
                return (
                  <button type="button" key={m.id} onClick={() => toggle(m.url)} title={m.filename}
                    className={`relative aspect-[4/5] rounded-lg overflow-hidden border-2 transition-[border-color,transform] hover:scale-[1.02] ${sel ? "border-[#E63946]" : "border-transparent"}`}
                    data-testid={`media-item-${m.id}`}>
                    <img src={`${BACKEND}${m.url}`} alt={m.filename} loading="lazy" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }} />
                    {sel && <span className="absolute top-1.5 right-1.5 w-6 h-6 rounded-full bg-[#E63946] text-white flex items-center justify-center"><Check size={14} /></span>}
                  </button>
                );
              })}
            </div>
          )}
        </div>
        <DialogFooter className="items-center">
          <span className="text-xs text-slate-400 mr-auto" data-testid="media-library-count">{picked.length} selected • {items.length} in library</span>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button disabled={!picked.length} onClick={confirm} className="bg-[#E63946] hover:bg-[#d12836]" data-testid="media-library-use">Use selected</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
